import { NgxSpinnerService } from 'ngx-spinner';
import { GetService } from 'src/app/Services/get.service';
import { URLs } from 'src/app/URLs';
import {    Component, ViewChild, OnDestroy ,OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';

import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';


export interface UserData {
  id: string;
  name: string;
  progress: string;
  fruit: string;
}

@Component({
  selector: 'app-page-manager',
  templateUrl: './page-manager.component.html',
  styleUrls: ['./page-manager.component.scss'],
})
export class PageManagerComponent implements OnInit, OnDestroy {
  selectedSprtBy: number;
  checked: boolean = false;
  selectedValue: string;
  subPagesUrl = URLs.subPages;
  websiteUrl=environment.websiteUrl;
  pagemanagerSubscribtions= new Subscription();
  visibilitySubscription = new Subscription();
  pageLinks = [
    '',
    'about',
    'partners',
    'calicoast',
    'baymount',
    'baymount/thank-you',
    '/calicoast/thank-you',
    'careers',
    '',
    'homeowners',
    'contact-us',
    'contact-us/thank-you',
    'careers/applications/thank-you-applicant',
    '404',
    '',
    '',
    ''

  ];;
  sorts: sorts[] = [
    { value: 'Last-0', viewValue: 'Last' },
    { value: 'Active-1', viewValue: 'Active' },
    { value: 'Inactive-2', viewValue: 'Inactive' },
  ];

  // displayedColumns: string[] = ['id', 'name', 'progress', 'fruit'];
  // dataSource: MatTableDataSource<UserData>;

  displayedColumns: string[] = [
    'title',
    // 'lastUpdated',
    // 'pageVisibility',
    'editPage',

  ];
  dataSource = new MatTableDataSource<IsubPages>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;
  constructor(private service: GetService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.spinner.show()
     this.pagemanagerSubscribtions=this.service.get(this.subPagesUrl).subscribe((res) => {

      // this.dataSource = res.response.data;

      setTimeout(() => {
        this.spinner.hide()
      }, 800);


      this.dataSource = new MatTableDataSource(res.response.data);

      setTimeout(() => (this.dataSource.paginator = this.paginator));
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  checkBoxvalue(event, id) {


    this.checked = event;
    let data: any = { id: id, is_visible: Number(event) };
   this.visibilitySubscription = this.service.Post(URLs.setPageVisible + id, data).subscribe(
      (data) => {

        // this.all = data.response.data;

        // this.dataSource = data.response.data;
      },
      (err) => {



      })

  }
  ngOnDestroy(): void {
    this.pagemanagerSubscribtions.unsubscribe();
    this.visibilitySubscription.unsubscribe();


  }
}

interface IsubPages {
  id: number;
  is_visible: number;
  order: number;
  page_id: number;
  subpage_name: string;
  title: string;
  title_ar: string;
}

interface sorts {
  value: string;
  viewValue: string;
}

